'use client'

import { Cell } from '@vinted/web-ui'

import { businessAccountFromUserDto } from '@marketplace-web/business-accounts/business-accounts-data'
import { useSession } from '@marketplace-web/shared/session-data'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

const TRANSLATE_PREFIX = 'policies_settings.legal_imprint'

const LegalImprint = () => {
  const { user } = useSession()
  const businessAccount = businessAccountFromUserDto(user)
  const translate = useTranslate(TRANSLATE_PREFIX)

  if (!businessAccount) return null

  const { legal_name: legalName, legal_code: legalCode } = businessAccount

  return (
    <>
      <Cell title={translate('title')} />
      <Cell title={translate('business_name')}>{legalName}</Cell>
      <Cell title={translate('legal_code')}>{legalCode}</Cell>
    </>
  )
}

export default LegalImprint
